export default "__VITE_ASSET__d4d1beca__"